import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IsActiveMatchOptions, Router, RouterModule } from '@angular/router';
import { FuseNavigationItem } from '../../../../core/models/interface/navigation.types';
import { AppService } from '../../../../core/services/app-service';

@Component({
  selector: 'fuse-vertical-navigation-basic-item',
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './basic.component.html',
})
export class FuseVerticalNavigationBasicItem {
  @Input() item!: FuseNavigationItem;
  @Input() name!: string;

  constructor(private router: Router, private appService: AppService) { }
  onMenuClick(item: FuseNavigationItem) {
    const ancho = window.innerWidth;

    if (ancho < 768) {
      this.appService.toggleSidebar();
    }
  }

}
